<app-header></app-header>

<main class="fees-container">
  <section class="hero-section">
    <div class="hero-content">
      <h1 class="hero-title">
        Choose Your Perfect
        <span class="gradient-text">Business Plan</span>
      </h1>
      <p class="hero-subtitle">
        Unlock your listing's full potential with our comprehensive pricing
        plans designed for businesses of all sizes. From startups to
        enterprises, find the perfect solution to maximize your reach and
        results.
      </p>
    </div>
  </section>

  <section class="pricing-section">
    <div class="pricing-container">
      <div class="pricing-grid">
        <div
          *ngFor="let plan of plans"
          class="pricing-card"
          [class.popular]="plan.popular"
          [attr.data-color]="plan.color"
        >
          <div *ngIf="plan.popular" class="popular-badge">
            Most Popular Choice
          </div>

          <div class="plan-header" [attr.data-color]="plan.color">
            <h3 class="plan-name">{{ plan.name }}</h3>
            <div class="plan-price">
              <span class="price-amount"> ${{ plan.price.toFixed(2) }} </span>
              <span *ngIf="plan.price >= 0" class="price-period">/listing</span>
            </div>
            <p class="plan-description">{{ plan.description }}</p>
          </div>

          <div class="plan-features">
            <ul class="features-list">
              <li class="feature-item">
                <div class="feature-icon icon-calendar"></div>
                <div class="feature-content">
                  <span class="feature-label">Listing Duration</span>
                  <span class="feature-value"
                    >{{ plan.features.listingDuration }} days</span
                  >
                </div>
              </li>

              <li class="feature-item">
                <div class="feature-icon icon-image"></div>
                <div class="feature-content">
                  <span class="feature-label">Image Gallery</span>
                  <span class="feature-value">{{
                    plan.features.imagesAllowed
                  }}</span>
                </div>
              </li>

              <li class="feature-item">
                <div class="feature-icon icon-text"></div>
                <div class="feature-content">
                  <span class="feature-label">Description Length</span>
                  <span class="feature-value">{{
                    plan.features.descriptionLength
                  }}</span>
                </div>
              </li>

              <li class="feature-item">
                <div class="feature-icon icon-search"></div>
                <div class="feature-content">
                  <span class="feature-label">Priority in Search</span>
                  <span
                    class="feature-value"
                    [class.feature-yes]="
                      plan.features.appearsHigherInSearch === 'Yes'
                    "
                  >
                    {{ plan.features.appearsHigherInSearch }}
                  </span>
                </div>
              </li>

              <li class="feature-item">
                <div class="feature-icon icon-star"></div>
                <div class="feature-content">
                  <span class="feature-label">Featured Placement</span>
                  <span
                    class="feature-value"
                    [class.feature-yes]="
                      plan.features.listingInFeaturedSection === 'Yes'
                    "
                  >
                    {{ plan.features.listingInFeaturedSection }}
                  </span>
                </div>
              </li>

              <li class="feature-item">
                <div class="feature-icon icon-bulb"></div>
                <div class="feature-content">
                  <span class="feature-label">Recommendations</span>
                  <span
                    class="feature-value"
                    [class.feature-yes]="
                      plan.features.listingInSuggestedItems === 'Yes'
                    "
                  >
                    {{ plan.features.listingInSuggestedItems }}
                  </span>
                </div>
              </li>

              <li class="feature-item">
                <div class="feature-icon icon-email"></div>
                <div class="feature-content">
                  <span class="feature-label">Email Notifications</span>
                  <span
                    class="feature-value"
                    [class.feature-yes]="
                      plan.features.emailNotifications === 'Yes'
                    "
                  >
                    {{ plan.features.emailNotifications }}
                  </span>
                </div>
              </li>

              <li class="feature-item">
                <div class="feature-icon icon-refresh"></div>
                <div class="feature-content">
                  <span class="feature-label">Free Relisting</span>
                  <span
                    class="feature-value"
                    [class.feature-yes]="
                      plan.features.freeRelist.includes('Yes')
                    "
                  >
                    {{ plan.features.freeRelist }}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="info-section">
    <div class="info-container">
      <div class="info-grid">
        <div class="info-card">
          <div class="info-icon">💳</div>
          <div class="info-content">
            <h3 class="info-title">Transparent Pricing</h3>
            <p class="info-description">
              You can easily add funds to your account through the Profile
              section. Once your balance is topped up, you can use those funds
              to create and publish any listings you choose whether vehicles,
              real estate, marketplace or jobs. Managing your balance from one
              place makes listing faster and more convenient.
            </p>
          </div>
        </div>

        <div class="info-card">
          <div class="info-icon">🚀</div>
          <div class="info-content">
            <h3 class="info-title">Instant Activation</h3>
            <p class="info-description">
              Once you submit your listing, our team promptly begins the review
              process to ensure it meets our quality and cultural standards. As
              soon as your listing is approved, it goes live on the platform,
              allowing you to start receiving qualified inquiries and connect
              with potential buyers within minutes.
            </p>
          </div>
        </div>

        <div class="info-card">
          <div class="info-icon">🔒</div>
          <div class="info-content">
            <h3 class="info-title">Enterprise Security</h3>
            <p class="info-description">
              Bank-level encryption protects all transactions. Your listing plan
              includes performance guarantees and cannot be downgraded once
              published, ensuring consistent visibility.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<app-footer></app-footer>
